import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
    FooterContainer as SourceFooterContainer,
    mapStateToProps as sourceMapStateToProps,
} from 'AdvoxComponent/Footer/Footer.container';
import Footer from 'Component/Footer/Footer.component';
import { CHECKOUT_URL } from 'Route/Checkout/Checkout.config';
import history from 'Util/History';

/** @namespace Pwa/Component/Footer/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    header_logo_src: state.ConfigReducer.header_logo_src,
    logo_alt: state.ConfigReducer.logo_alt,
});

/** @namespace Pwa/Component/Footer/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Pwa/Component/Footer/Container */
export class FooterContainer extends SourceFooterContainer {
    containerFunctions = {
        scrollTop: this.scrollTop.bind(this),
    };

    state = {
        ...this.state,
        scriptTag: null,
    };

    containerProps() {
        const { logo_alt, header_logo_src, postcode, city, street_line1, street_line2, phone, email } = this.props;
        const {
            location: { pathname },
        } = history;

        const isCheckout = pathname.includes(CHECKOUT_URL);

        return {
            ...super.containerProps(),
            postcode,
            city,
            street_line1,
            street_line2,
            phone,
            email,
            header_logo_src,
            logo_alt,
            isCheckout,
        };
    }

    render() {
        return <Footer {...this.containerProps()} {...this.containerFunctions} />;
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FooterContainer));
